import { render, staticRenderFns } from "./create-entity.vue?vue&type=template&id=0fb1caab&scoped=true&"
import script from "./create-entity.vue?vue&type=script&lang=js&"
export * from "./create-entity.vue?vue&type=script&lang=js&"
import style0 from "./create-entity.vue?vue&type=style&index=0&id=0fb1caab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1caab",
  null
  
)

export default component.exports